module.exports = {"previous":"Anterior","next":"Siguiente"};